import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Navigate the resource library using the <strong>category tree</strong> on the left. Click a category to see its available courses and materials." id="navigate_the_resource_library_using_the.f11d5bc9" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Browsing Resources" id="browsing_resources.2c391fdc" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>search bar</strong> to quickly find resources by name. Results update as you type." id="use_the_search_bar_to_quickly_find_resou.6fc72e83" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Searching" id="searching.2df96c6a" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Select a resource to view its details, including <strong>description</strong>, <strong>requirements</strong>, and <strong>availability</strong>." id="select_a_resource_to_view_its_details_in.da26724b" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Resource Details" id="resource_details.90ff5f5a" />
        }
    ],
    title: <FormattedMessage defaultMessage="Resources" id="resources.73e9320e" />
};
